import styled from 'styled-components/macro';
import Page from '../Page/Page';

// TODO: Delete this line after replacing `div` with the proper element
export const ErrorPage = styled(Page)``;
